import styled, { css, keyframes } from "styled-components";
import { NavItems } from "../../../data/NavItems";
import { Link } from "react-router-dom";

const navItemFade = keyframes`
  from {
    opacity: 0;
    transform: translate(50px);
  }
  to {
    opacity: 1;
    transform: translate(0px);
  }
`;

const navItemAnimation = ({ index }) => css`
  animation: ${navItemFade} 0.5s ease forwards ${index / NavItems.length + 0.5}s;
`;

export const Nav = styled.nav`
  height: 80px;
  width: 100%;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  z-index: 98;
  transition: all 1s ease-in-out;
  background: ${({ theme }) => theme.colors.secondary};
  top: ${({ scrollDirection }) =>
    scrollDirection === "down" ? "-80px" : "0px"};
`;

export const Logo = styled.h3`
  font-size: 3rem;
  font-family: "Source Code Pro", monospace;
  margin: 1.5rem 0;
  background: linear-gradient(
    to right,
    ${({ theme }) => theme.colors.green} 0%,
    ${({ theme }) => theme.colors.blue} 100%
  );
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  @media (max-width: ${({ theme }) => theme.mobile}) {
    font-size: 4rem;
  }
`;

export const SocialIcons = styled.div`
  display: none;

  @media (max-width: ${({ theme }) => theme.mobile}) {
    width: 150px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    a {
      margin: 0 0.5rem;
      font-size: 2rem;
    }
  }
`;

export const MenuIcon = styled.div`
  cursor: pointer;
  background: ${({ theme, menuOpen }) =>
    menuOpen ? "none" : theme.colors.orange};
  transition: ${({ theme }) => theme.transition};
  padding: 0.7rem;
  border-radius: 5px;
  display: none;
  position: absolute;
  right: 20px;
  z-index: 999;

  @media (max-width: ${({ theme }) => theme.mobile}) {
    display: inline-block;
  }
`;

export const LineOne = styled.div`
  width: 15px;
  height: 3px;
  margin: 5px 0;
  background: linear-gradient(
    135deg,
    ${({ theme }) => theme.colors.orange} 0%,
    ${({ theme }) => theme.colors.primary} 100%
  );
  transition: ${({ theme }) => theme.transition};
  transform: ${({ menuOpen }) =>
    menuOpen ? "rotate(-45deg) translate(-5px, 6px) scaleX(2)" : "none"};
`;

export const LineTwo = styled.div`
  width: 30px;
  height: 3px;
  margin: 5px 0;
  background: linear-gradient(
    135deg,
    ${({ theme }) => theme.colors.orange} 0%,
    ${({ theme }) => theme.colors.primary} 100%
  );
  opacity: ${({ menuOpen }) => (menuOpen ? 0 : 1)};
  transition: ${({ theme }) => theme.transition};
`;

export const LineThree = styled.div`
  width: 15px;
  height: 3px;
  margin: 5px 0;
  margin-left: ${({ menuOpen }) => (menuOpen ? 0 : "15px")};
  background: linear-gradient(
    135deg,
    ${({ theme }) => theme.colors.orange} 0%,
    ${({ theme }) => theme.colors.primary} 100%
  );
  transition: ${({ theme }) => theme.transition};
  transform: ${({ menuOpen }) =>
    menuOpen ? "rotate(45deg) translate(-5px, -6px) scaleX(2)" : "none"};
`;

export const NavList = styled.ul`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-size: 14px;
  flex-wrap: wrap;

  @media (max-width: ${({ theme }) => theme.mobile}) {
    width: 24rem;
    height: 100vh;
    background: ${({ theme }) => theme.colors.lightSecondary};
    transition: ${({ theme }) => theme.transition};
    top: 0;
    right: ${({ menuOpen }) => (menuOpen ? 0 : "-24rem")};
    position: fixed;
    padding-top: 3rem;
    justify-content: flex-start;
    flex-direction: column;
    z-index: 998;
  }
`;

export const NavItemStyled = styled.li`
  margin: 0.2rem 0.7rem;
  &:last-child {
    margin-right: 0;
  }
  @media (max-width: ${({ theme }) => theme.mobile}) {
    opacity: 0;
    margin: 1.2rem 0;
    ${({ menuOpen }) => (menuOpen ? navItemAnimation : null)};
  }
`;

export const NavLink = styled(Link)`
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.primary};
  letter-spacing: 1.5px;

  &::after {
    content: "";
    display: block;
    height: 3px;
    background: ${({ theme }) => theme.colors.orange};
    transition: all ease-in-out 300ms;
    width: 0;
  }

  &:hover {
    &::after {
      width: 100%;
    }
  }
`;
